import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getUserCustomers, ResetPassword as ResetPasswordMethod} from '../../actions/UserActions';
import LinkedSapAccounts from "../user-management/LinkedSapAccounts";
import {
  deleteUserSapAccount,
  getExclusionList,
  getUserSapAccounts,
  updateExclusionList
} from "../../requests/UserRequests";
import ExclusionList from "../user-management/exclusions/ExclusionList";
import {canManageOwnSAPAccounts, canManageUsers} from "../../PermissionSelectors";
import {getAccountTypes} from "../../requests/AccountTypeRequests";
import {updateAccountTypes} from "../../actions/InvoiceActions";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      currentPasswordValid: true,
      newPasswordValid: true,
      confirmNewPasswordValid: true,
    };
    this.passwordChange = this.passwordChange.bind(this);
    this.onResetClick = this.onResetClick.bind(this);
  }

  componentDidMount() {
    getAccountTypes().then((accountTypes) => {
      updateAccountTypes(this.props.dispatch, accountTypes);
    });
  }

  onResetClick() {
    if (this.validateFields()) {
      ResetPasswordMethod(this.props.dispatch, this.state.currentPassword, this.state.newPassword, this.state.confirmNewPassword);
    }
  }

  validateFields() {
    let isModelStateValid = false;
    this.setState({currentPasswordValid: this.state.currentPassword !== ''});
    this.setState({newPasswordValid: this.state.newPassword !== ''});
    this.setState({confirmNewPasswordValid: this.state.confirmNewPassword !== ''});

    if (this.state.currentPassword !== '' && this.state.newPassword !== '' && this.state.confirmNewPassword !== '') {
      isModelStateValid = true;
    }
    return isModelStateValid;
  }

  passwordChange = (e) => {
    if (e.currentTarget.name === 'currentPassword') {
      this.setState({currentPassword: e.target.value});
      this.setState({currentPasswordValid: e.target.value !== ''});
    }
    if (e.currentTarget.name === 'newPassword') {
      this.setState({newPassword: e.target.value});
      this.setState({newPasswordValid: e.target.value !== ''});
    }
    if (e.currentTarget.name === 'confirmNewPassword') {
      this.setState({confirmNewPassword: e.target.value});
      this.setState({confirmNewPasswordValid: e.target.value !== ''});
    }
  }

  errorClass = valid => (valid ? '' : 'invalid');

  render() {
    const {
      currentPasswordValid,
      newPasswordValid,
      confirmNewPasswordValid,
    } = this.state;
    return (
      <div className="container">
        <div className={"row"}>
          <div className={"col"}>
            <div className={"card"}>
              <div className={"row"}>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <h4>Reset Password</h4>
                  <div className="form-group">
                    <label className="col-form-label-sm text-secondary" htmlFor="firstName">Confirm your Current
                      Password</label>
                    <input type="password" className={`form-control ${this.errorClass(currentPasswordValid)}`}
                           name="currentPassword" placeholder="Current Password" onChange={this.passwordChange}/>
                    {currentPasswordValid ? '' : <h6 className="invalid-Text">
                      <small>Required.</small>
                    </h6>}
                  </div>
                  <div className="form-group">
                    <label className="col-form-label-sm text-secondary" htmlFor="lastName">Enter your new
                      password</label>
                    <input type="password" className={`form-control ${this.errorClass(newPasswordValid)}`}
                           name="newPassword"
                           placeholder="New Password"
                           onChange={this.passwordChange}/>
                    {newPasswordValid ? '' : <h6 className="invalid-Text">
                      <small>Required.</small>
                    </h6>}
                  </div>
                  <div className="form-group">
                    <input type="password" className={`form-control ${this.errorClass(confirmNewPasswordValid)}`}
                           name="confirmNewPassword" placeholder="Confirm new password" onChange={this.passwordChange}/>
                    {confirmNewPasswordValid ? '' : <h6 className="invalid-Text">
                      <small>Required.</small>
                    </h6>}
                  </div>
                  <div className="form-group text-center">
                    <button className="btn btn-primary buttonColor col-lg-6 col-md-6 col-sm-6"
                            onClick={this.onResetClick}>
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.props.canManageOwnSAPAccounts && <React.Fragment>
          <div className="row mt-4">
            <div className={"col-12"}>
              <LinkedSapAccounts userId={this.props.userId}
                                 getAccounts={(userId) => {
                                   getUserCustomers(this.props.dispatch, "", false);
                                   return getUserSapAccounts(userId);
                                 }} deleteAccount={deleteUserSapAccount}
                                 accountTypes={this.props.accountTypes}/>
            </div>
          </div>

          {this.props.primaryAccountTypeId === 3 && <div className="row mt-4">
            <div className={"col-12"}>
              {this.props.canManageUsers &&
                <ExclusionList getExclusions={(userId) => {
                  getUserCustomers(this.props.dispatch, "", false);
                  return getExclusionList(userId)
                }} updateExclusions={updateExclusionList}
                               userId={this.props.userId}/>
              }
            </div>
          </div>
          }
        </React.Fragment>}
      </div>
    );
  }
}

export default connect((store, props) => ({
  userId: store.default.currentUser.UserId,
  primaryAccountTypeId: store.default.currentUser.PrimaryAccountTypeId,
  accountTypes: store.default.accountTypes,
  canManageOwnSAPAccounts: canManageOwnSAPAccounts(store, props),
  canManageUsers: canManageUsers(store, props),
}))(ResetPassword);
